import React from 'react';
import { useZunelo } from '../../context/ZuneloContext';
import { AGENT_AXES } from '../../domain/filtering';
import { defaultAxisFilterState, filterByAxes } from '../../domain/multiAxisFiltering';
import { FilterButton } from '../../ui/common/FilterButton';
import { AgentsCard } from './AgentsCard';
import { CardSkeleton, ErrorState, EmptyState } from '../../ui/common';

export const AgentsView: React.FC = () => {
  const {
    agents,
    activeAxisFilters,
    setActiveAxisFilters,
    selectedId,
    loadingSources,
    errors,
    retry,
  } = useZunelo();

  const currentFilters = activeAxisFilters['agents'] || defaultAxisFilterState(AGENT_AXES);
  const isLoading = loadingSources.agents && agents.length === 0;
  const error = errors.agents;

  const filteredAgents = filterByAxes(agents, AGENT_AXES, currentFilters);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
      }}
    >
      <FilterButton
        axes={AGENT_AXES}
        items={agents}
        value={currentFilters}
        onChange={(next) => setActiveAxisFilters('agents', next)}
      />

      {/* Error State */}
      {error && (
        <ErrorState
          title="Error en Agentes"
          message={error}
          onRetry={() => retry('agents')}
          isRetrying={loadingSources.agents}
        />
      )}

      {/* Loading Skeleton */}
      {isLoading ? (
        <CardSkeleton count={3} variant="agents" height={150} />
      ) : (
        /* Cards List */
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {filteredAgents.map((agent) => (
            <AgentsCard
              key={agent.sessionId || agent.name}
              agent={agent}
              isSelected={selectedId === agent.ticket}
            />
          ))}
          {filteredAgents.length === 0 &&
            !error &&
            (agents.length === 0 ? (
              <EmptyState message="Aún no hay sesiones de agentes activas." />
            ) : (
              <EmptyState
                message="No hay sesiones de agentes para el filtro seleccionado."
                actionLabel="Ver todos"
                onAction={() => setActiveAxisFilters('agents', defaultAxisFilterState(AGENT_AXES))}
              />
            ))}
        </div>
      )}
    </div>
  );
};
